export default "__VITE_ASSET__DD6nJ_mv__"